import React from "react";
import { Typography } from "@mui/material";

const Footer = ({ style, children }) => {
  return (
    <div style={style} className="footer">
      <div className="footerChildren">{children}</div>
      <div>
        <Typography
          sx={{
            textAlign: "center",
            mt: 1,
            fontSize: 14,
            fontWeight: 400,
            opacity: 0.7,
          }}
          // color="text.secondary"
        >
          Powered by Stayflexi
        </Typography>
      </div>
    </div>
  );
};

export default Footer;
